// See templates.json for configuration options

import React from 'react'

import { withStyles } from '@material-ui/core/styles'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { LAYOUT_DRAWER_TABS_TOOLS_DOWNLOAD_EXPANDED } from 'api/actions'
import * as Model from 'api/model'
import AccordionWrapper from 'drawer/tabs/AccordionWrapper'
import DownloadMap from 'drawer/tabs/tools/DownloadMap/DownloadMap'
import ToolsPrint from 'drawer/tabs/tools/panels/ToolsPrint'
import Upgrade from 'drawer/tabs/Upgrade'

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 26,
    paddingBottom: 10,
    rowGap: 10
  }
})

class ToolsPanelDownload extends React.Component {
  constructor (props) {
    super(props)
    const { title } = props
    this.pure = {}
    this.pure.title = title
    this.pure.headerIcon = <CloudDownloadIcon />
    this.pure.upgradeText = Model.get('config.layout.drawer.tabs.tools.downloadgroup.upgrade.text', 'Upgrade to Pozi Enterprise')
    this.pure.upgradeURL = Model.get('config.layout.drawer.tabs.tools.downloadgroup.upgrade.url', '')
    this.pure.upgradeURLLabel = Model.get('config.layout.drawer.tabs.tools.downloadgroup.upgrade.urlLabel', 'Learn More')
    this.pure.upgradeMarkup = <Upgrade text={this.pure.upgradeText} url={this.pure.upgradeURL} urlLabel={this.pure.upgradeURLLabel} />
  }

  render () {
    const { classes, enabled, expanded, toggleExpansionPanel } = this.props

    let markup = null
    if (!enabled) {
      markup = this.pure.upgradeMarkup
    } else if (expanded) {
      markup = (
        <div className={classes.root}>
          <ToolsPrint />
          <DownloadMap />
        </div>
      )
    }

    return (
      <AccordionWrapper
        licensed={enabled}
        expanded={expanded}
        onChange={toggleExpansionPanel}
        headerIcon={this.pure.headerIcon}
        title={this.pure.title}
        bExcludeExpandIcon={false}
      >
        {markup}
      </AccordionWrapper>
    )
  }
}

ToolsPanelDownload.propTypes = {
  classes: PropTypes.object.isRequired,
  enabled: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  expanded: PropTypes.bool.isRequired,
  toggleExpansionPanel: PropTypes.func.isRequired
}

function mapStateToProps (state, ownProps) {
  const enabled = get(state, 'config.layout.drawer.tabs.tools.downloadgroup.visible', true) // See templates.json
  const title = get(state, 'config.layout.drawer.tabs.tools.downloadgroup.title', 'Print/Save') // See templates.json
  const expanded = get(state, 'config.' + LAYOUT_DRAWER_TABS_TOOLS_DOWNLOAD_EXPANDED, false)
  return {
    enabled,
    title,
    expanded
  }
}

const mapDispatchToProps = dispatch => {
  return {

  }
}

export default (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ToolsPanelDownload)
  )
)
